import _ from './app.module.scss'
import React from 'react'
import {Footer} from './components/footer'
import {Header} from './components/header'
import {Toolbar} from './components/toolbar'
import {SafeAreaBlur} from './components/safe-area-blur'
import {Content} from './components/content'
import {AppFooter} from './components/app-footer'
import {Backdrop} from './components/backdrop'
import {ScrollAnchor} from './components/scroll-anchor'
import {useNavbarAlphas} from './hooks/use-navbar-alphas'
import {useNavbarHideOnScroll} from './hooks/use-navbar-hide-on-scroll'
import {useDataInputProvider} from './hooks/use-data-input-provider'
import {useCustomBodyBackground} from './hooks/use-custom-body-background'
import {useNotificationSettings} from './hooks/use-notification-settings'
import {useScrollTopOnNavigate} from './hooks/use-scroll-top-on-navigate'
import {useLayoutDynamics} from './hooks/use-layout-dynamics'
import {useGlobalActions} from './hooks/use-global-actions'
import {useAutoscrollStopOnNavigate} from './hooks/use-autoscroll-stop-on-navigate'
import {useSharedStore} from './state/shared-store-context'
import {boot} from './boot'
import {AppHeader} from './components/app-header'
import {DialogOutlet} from './components/dialog-outlet'
import {isAppRoute} from './shared/app-routes'
import {Loader} from './components/loader'
import {usePublicConfig} from './hooks/use-public-config'
import {useLocation, useRoutes} from 'react-router-dom'
import {useIs1024} from './hooks/use-is-1024'
import {isLoggedIn} from './shared/session'

await boot.config()
export function App() {
    useDataInputProvider()
    useCustomBodyBackground((pathname) =>
        !pathname.startsWith('/$') || pathname.startsWith('/auth') ? 'var(--surface-base)' : null)
    useGlobalActions()
    useNavbarAlphas()
    useNavbarHideOnScroll()
    useNotificationSettings()
    useScrollTopOnNavigate()
    useLayoutDynamics()
    useAutoscrollStopOnNavigate()
    usePublicConfig()
    const {sharedState} = useSharedStore()
    const {pathname} = useLocation()
    const is1024 = useIs1024()
    const sessionStarting = isAppRoute(pathname) && sharedState.sessionStatus === 'loading'
    const startupError = sharedState.publicConfigError || (isAppRoute(pathname) && sharedState.sessionStatus === 'error')
    return <>
        {boot.run()}
        <Header/>
        <Toolbar/>
        <div className={_.appShell}>
            <Content className={_.appMain}>
                {!sharedState.publicConfig || sessionStarting ? <div className={_.configStartup}>
                    {!startupError && <Loader upfront active color={'primary'}/>}
                    {startupError && <p>Unable to start the application. Refresh to try again.</p>}
                </div> : <>
                    {isAppRoute() && is1024 && !pathname.startsWith('/auth')
                        && !(pathname.startsWith('/legal') && !isLoggedIn()) && <AppHeader/>}
                    <AppRoutes/>
                    <ScrollAnchor/>
                    {boot.content()}
                    <Backdrop/>
                </>}
            </Content>
            <AppFooter className={_.appFooter}/>
        </div>
        <DialogOutlet/>
        <Footer/>
        <SafeAreaBlur/>
        {boot.hiddenContent()}
    </>
}
const AppRoutes = () => useRoutes(boot.routes())
